import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Hero() {
  const [zip, setZip] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (zip.trim()) navigate(`/free-quote?zip=${zip.trim()}`);
  };

  return (
    <section
      className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage:
          "url('https://public.readdy.ai/ai/img_res/7a5454c4d72a7d40cf9afd33726e339d.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center top",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 py-24 md:py-32 flex flex-col items-center text-center">
        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/30 rounded-full px-4 py-1.5 mb-5">
          <span className="w-2 h-2 rounded-full bg-green-400 inline-block"></span>
          <span className="text-white text-sm font-medium">Nationwide USA · Free Quotes · No Obligation</span>
        </div>

        <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-4">
          Get Matched with Top<br />
          <span className="text-green-400">Tree Service Pros</span> Near You
        </h1>
        <p className="text-white/80 text-lg md:text-xl max-w-2xl mb-10">
          Compare licensed, insured tree trimming professionals in your area. Free quotes, real reviews, transparent pricing.
        </p>

        {/* Zip Search Bar */}
        <form onSubmit={handleSearch} className="w-full max-w-xl flex flex-col sm:flex-row gap-3">
          <div className="flex-1 relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-gray-400">
              <i className="ri-map-pin-line text-lg"></i>
            </div>
            <input
              type="text"
              value={zip}
              onChange={(e) => setZip(e.target.value)}
              placeholder="Enter your zip code..."
              maxLength={10}
              className="w-full h-14 pl-11 pr-4 rounded-xl bg-white text-gray-800 text-base font-medium focus:outline-none focus:ring-2 focus:ring-green-400 placeholder-gray-400"
            />
          </div>
          <button
            type="submit"
            className="h-14 px-8 bg-[#1B4332] hover:bg-[#2d6a4f] text-white font-bold text-base rounded-xl transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            Find Pros <i className="ri-arrow-right-line"></i>
          </button>
        </form>

        {/* Quick stats */}
        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {[
            { icon: "ri-user-star-line", text: "500+ Verified Pros" },
            { icon: "ri-shield-check-line", text: "Licensed & Insured" },
            { icon: "ri-star-fill", text: "4.9★ Avg Rating" },
            { icon: "ri-time-line", text: "Responds in 24hrs" },
          ].map((s) => (
            <div key={s.text} className="flex items-center gap-2 text-white/85 text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${s.icon} text-green-400`}></i>
              </div>
              <span>{s.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
